import { styled } from "styled-components";
import theme from "../../styles/theme";
import { Button } from "@mui/material";
import { useQueryClient } from 'react-query';
import { MODAL_QUERY_NM, useGetModalInfo } from "../../interfaces/modal";
import React, { useEffect } from "react";
import { CommonModalWrap } from "../../styles/common";

const MsgWindow = styled.div`
    background: ${theme.color.white[100]};
    width: 50%;
    height: ${(props)=>props.mHeight?props.mHeight:'50vh'};
    border-radius: 18px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const MsgBox = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
`;

const MsgButtonBox = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
`;

const CommonModal = ({modalInfo}) => {

    const queryClient = useQueryClient();

    const customOkClick = () => {
        modalInfo.okButton();
        queryClient.setQueryData([MODAL_QUERY_NM],{show:false});
    }

    return (
        <CommonModalWrap>
            <MsgWindow mHeight={modalInfo.height}>
                <MsgBox>
                    {modalInfo.msg}
                </MsgBox>
                {modalInfo.okButton ?
                    <MsgButtonBox>
                        <Button fullWidth variant="contained" onClick={customOkClick}>OK</Button>
                        <Button fullWidth variant="contained" onClick={()=>queryClient.setQueryData([MODAL_QUERY_NM],{show:false})}>Cancel</Button>
                    </MsgButtonBox>
                :
                    <MsgButtonBox>
                        <Button fullWidth variant="contained" onClick={()=>queryClient.setQueryData([MODAL_QUERY_NM],{show:false})}>OK</Button>
                    </MsgButtonBox>
                }
            </MsgWindow>
        </CommonModalWrap>
    )
}

export default CommonModal;